import { useLayoutEffect, useState, type RefObject } from "react";
import { resolveMultiSelectRailHostBlockId } from "./multiSelectRailAnchor";

export function useMultiSelectRailHostBlockId(
  canvasRootRef: RefObject<HTMLElement | null>,
  selectedBlockIds: readonly string[],
  primaryBlockId: string | null,
): string | null {
  const [hostBlockId, setHostBlockId] = useState<string | null>(null);
  const selectionKey = selectedBlockIds.join("\u0001");

  useLayoutEffect(() => {
    if (selectedBlockIds.length <= 1) {
      setHostBlockId(null);
      return;
    }

    const canvasRoot = canvasRootRef.current;
    if (!(canvasRoot instanceof HTMLElement)) {
      return;
    }

    const root = canvasRoot;

    function measure() {
      const nextHostId = resolveMultiSelectRailHostBlockId(selectedBlockIds, root);
      setHostBlockId(previous => (previous === nextHostId ? previous : nextHostId));
    }

    measure();
    root.addEventListener("scroll", measure, { passive: true });
    window.addEventListener("resize", measure);
    return () => {
      root.removeEventListener("scroll", measure);
      window.removeEventListener("resize", measure);
    };
  }, [canvasRootRef, selectionKey, selectedBlockIds]);

  if (selectedBlockIds.length <= 1) {
    return null;
  }

  return (
    hostBlockId ??
    (primaryBlockId !== null && selectedBlockIds.includes(primaryBlockId)
      ? primaryBlockId
      : selectedBlockIds[0] ?? null)
  );
}
